import { forwardRef, useCallback, useMemo } from 'react';
import styled from 'styled-components';
import { paddingSM } from '@atlas-frontend/design-tokens';
import { FocusRef } from '../../components';
import { CheckboxPicker } from '../../table';
import { FilterOption } from '../renderers';
import { useTableStoreValue } from '../TableContext';
import { createOnBlur } from './focusHandlers';
import { FilterInputProps } from './FilterInputProps';

const EMPTY_OPTIONS: FilterOption[] = [];
const EMPTY_VALUE: any[] = [];

export const OptionFilterInput = forwardRef<FocusRef, FilterInputProps>(
  (
    {
      onBlur,
      header: {
        column: { id: columnId, getFilterValue, setFilterValue },
      },
    },
    ref,
  ) => {
    const id = `${columnId}-filter-input`;
    const [options] = useTableStoreValue('options');

    const handleOnBlur = useMemo(
      () => createOnBlur<HTMLDivElement>(id, onBlur),
      [id, onBlur],
    );
    const handleChange = useCallback(
      (ids: any) => {
        if (ids === null || ids.length === 0) {
          setFilterValue(undefined);
          return;
        }
        setFilterValue(ids);
      },
      [setFilterValue],
    );

    return (
      <CheckboxWrapper
        id={id}
        className={id}
        onBlur={handleOnBlur}
        tabIndex={0}
      >
        <CheckboxPicker
          name={`${columnId}-filter-check`}
          options={options?.[columnId] ?? (EMPTY_OPTIONS as any)}
          value={(getFilterValue() as any) ?? EMPTY_VALUE}
          onChange={handleChange}
          ref={ref}
        />
      </CheckboxWrapper>
    );
  },
);

const CheckboxWrapper = styled.div`
  max-height: max(
    0px,
    calc(
      min(
          var(--atlas-tooltip-max-height, 400px),
          var(--atlas-tooltip-available-height, 100dvh)
        ) -
        ${paddingSM * 2}px
    )
  );
  overflow: auto;
`;
